export default __webpack_public_path__ + "static/media/pt-packages.dbb27462.svg";